<div
  class="modal show"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'open_add_modal_' + context?.nodeId"
  (click)="onBackdropClick()"
>
  <div
    class="modal-content mx-auto my-5 w-full sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
    [ngClass]="
      (context?.nodeId === '6a143360ca440a759a89fa08' && context?.recordID === 'invite') || context?.nodeId === '6a71ba85088685936bb93e65'
        ? 'max-w-[900px] bg-white border border-gray-200 text-gray-900 dark:bg-[#090D14] dark:border-[#1E2638] dark:text-white p-0'
        : 'max-w-[700px] bg-white dark:bg-coal-500'
    "
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header pr-2.5 pb-2 flex flex-col items-start gap-1">
      <span class="card-title text-base font-semibold">
        {{
          context?.clickedButton === "EDIT"
            ? "Edit Role"
            : addModalRenderer &&
                addModalRenderer.formData &&
                addModalRenderer.formData.formCollection
              ? addModalRenderer.formData.formCollection.formName
              : modalTitle
        }}
      </span>
      <!-- <span
        *ngIf="
          addModalRenderer &&
          addModalRenderer.formData &&
          addModalRenderer.formData.formCollection &&
          addModalRenderer.formData.formCollection.formDescription
        "
        class="text-xs text-gray-500 dark:text-gray-400"
      >
        {{ addModalRenderer.formData.formCollection.formDescription }}
      </span> -->
    </div>

    <div class="modal-body grid gap-5 px-0" *ngIf="context">
      <app-modal-renderer
        #addModalRenderer
        [nodeId]="context.nodeId"
        [activeModalContext]="context"
        (header)="setModalTitle($event)"
        [recordIDs]="context.recordID"
        (closeModal)="closeModal()"
        (formSaved)="onModalFormSaved($event)"
      >
      </app-modal-renderer>
    </div>
  </div>
</div>
